<template>
  <!-- 信息发布 -->
  <div class="page-solicitation">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form @keyup.enter.native="getTableList" class="com-search-box" ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="标题 :" prop="name">
              <el-input clearable v-model="form.name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <!-- 勿删 防止回车跳转问题 -->
          <el-col :span="8" style="display: none;">
            <el-form-item label="标题 :" prop="name">
              <el-input v-model="form.name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="创建时间 :">
              <el-date-picker v-model="time" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange"
                start-placeholder="开始时间" @change="timeChange" end-placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleCreate('add')">
            <svg-icon icon-class="add" />&nbsp;添加
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :row-key="(row)=>{ return row.schemeId }"
          :data="tableData" :cell-class-name="(item)=>{ if(item.columnIndex==1) return 'g-column-light-box222'}">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column label="活动名称" min-width="20%" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.activityName}}</span>
              <!-- <router-link class="m-btn" target="_blank"
                :to="{path: '/approve/notice-detail', query: {obj:encodeURIComponent(JSON.stringify(scope.row))}}">{{ scope.row.name }}</router-link> -->
            </template>
          </el-table-column>

          <el-table-column label="封面" min-width="10%">
            <template slot-scope="scope">
              <viewer :options="{ url: 'data-maxUrl' }">
                <img class="g-pointer" :src="scope.row.picture"
                  :data-maxUrl="scope.row.picture" alt :onerror="defaultImg"
                  style="width: 50px;">
              </viewer>
            </template>
            <!-- <template slot-scope="scope">{{ scope.$index+1 }}</template> -->
          </el-table-column>

          <el-table-column label="活动时间" min-width="30%">
            <template slot-scope="scope">
              <span>{{ scope.row.activityTime }} 至 {{ scope.row.activityEndTime }}</span>
            </template>
          </el-table-column>
          
          <el-table-column prop="activityDemand" label="活动要求" min-width="14%"></el-table-column>
          <el-table-column prop="activityQuota" label="活动名额" min-width="10%"></el-table-column>

          <el-table-column prop="createTime" label="剩余名额" min-width="15%">
            <template slot-scope="scope">
              <span>{{ scope.row.leftQuota }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="activityQuota" label="已报名" min-width="10%"></el-table-column> -->
          
          <!-- <el-table-column prop="statusName" label="发布状态" min-width="14%"></el-table-column> -->
           
          <!-- <el-table-column prop="createTime" label="创建时间" min-width="15%">
            <template slot-scope="scope">
              <span>{{$common.formatDateString(scope.row.createTime, 'yyyy-MM-dd')}}</span>
            </template>
          </el-table-column> -->

          <!-- <el-table-column prop="sequence" label="排序" min-width="8%"></el-table-column> -->

          <!-- <el-table-column prop="createTime" label="发布状态" min-width="15%">
            <template slot-scope="scope">
              <span>{{scope.row.status=='0'?'待发布':'已发布'}}</span>
            </template>
          </el-table-column> -->

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="20%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleCreate('detail', scope.row.id)">查看</a>

              <!-- <a class="m-btn mr-10" @click="handleTop(scope.row)">{{scope.row.top === '1' ? '取消置顶' : '置顶'}}</a> -->

              <!-- 1 已发布  0 待发布 -->
              <a class="m-btn mr-10" @click="handlePublish(scope.row)">{{scope.row.status === '1' ? '取消发布' : '发布'}}</a>

              <a class="m-btn mr-10" @click="handleCreate('edit', scope.row.id)" v-if="scope.row.status != '1'">编辑</a>

              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row.id)">删除</a>

              <a class="m-btn mr-10" @click="handleCancelAct(scope.row)" v-if="scope.row.status === '1'">活动取消</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <dialogCreateInfo ref="dialogCreateInfo" @refresh="restList"></dialogCreateInfo>
  </div>
</template>

<script>
import cmpMyExport from '@cmp/my-export'
import dialogCreateInfo from './dialog-create-info'
export default {
  components: {
    cmpMyExport,
    dialogCreateInfo
  },
  data() {
    return {
      defaultImg: this.$store.state.app.defaultImg,
      form: {
        name: '',
        dateStart: '',
        dateEnd: ''
      },
      time: [],

      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      typeList: [],
      tableData: [],
      listLoading: true,
      // 1 乐学堂 2 青少年研学 3 培训班 4 辽博讲堂 5 博淡雅集 6 辽博手作 7 亲子活动 8 其他公益活动  9 特色讲解  10 临时活动
      apiObj: {
        '1': {
          listApi: '/activitynew/personal/happy/list',
          deleteApi: '/activitynew/personal/happy/delete',
          publishApi: '/activitynew/personal/happy/publish',
          unpublishApi: '/activitynew/personal/happy/unpublish'
        },
        '2': {
          listApi: '/activitynew/personal/youth/list',
          deleteApi: '/activitynew/personal/youth/delete',
          publishApi: '/activitynew/personal/youth/publish',
          unpublishApi: '/activitynew/personal/youth/unpublish'
        },
        '3': {
          listApi: '/activitynew/personal/training/list',
          deleteApi: '/activitynew/personal/training/delete',
          publishApi: '/activitynew/personal/training/publish',
          unpublishApi: '/activitynew/personal/training/unpublish'
        },
        '4': {
          listApi: '/activitynew/personal/lecture/list',
          deleteApi: '/activitynew/personal/lecture/delete',
          publishApi: '/activitynew/personal/lecture/publish',
          unpublishApi: '/activitynew/personal/lecture/unpublish'
        },
        '5': {
          listApi: '/activitynew/personal/discourse/list',
          deleteApi: '/activitynew/personal/discourse/delete',
          publishApi: '/activitynew/personal/discourse/publish',
          unpublishApi: '/activitynew/personal/discourse/unpublish'
        },
        '6': {
          listApi: '/activitynew/personal/handicrafts/list',
          deleteApi: '/activitynew/personal/handicrafts/delete',
          publishApi: '/activitynew/personal/handicrafts/publish',
          unpublishApi: '/activitynew/personal/handicrafts/unpublish'
        },
        '7': {
          listApi: '/activitynew/personal/treasure/list',
          deleteApi: '/activitynew/personal/treasure/delete',
          publishApi: '/activitynew/personal/treasure/publish',
          unpublishApi: '/activitynew/personal/treasure/unpublish'
        },
        '8': {
          listApi: '/activitynew/personal/community/list',
          deleteApi: '/activitynew/personal/community/delete',
          publishApi: '/activitynew/personal/community/publish',
          unpublishApi: '/activitynew/personal/community/unpublish'
        },
        '9': {
          listApi: '/activitynew/personal/explanation/list',
          deleteApi: '/activitynew/personal/explanation/delete',
          publishApi: '/activitynew/personal/explanation/publish',
          unpublishApi: '/activitynew/personal/explanation/unpublish'
        },
        '10': {
          listApi: '/activitynew/personal/temporary/list',
          deleteApi: '/activitynew/personal/temporary/delete',
          publishApi: '/activitynew/personal/temporary/publish',
          unpublishApi: '/activitynew/personal/temporary/unpublish'
        }
      }
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        this.$nextTick(() => {
          this.$refs['form'].resetFields()
        })
        this.total = 0
        this.listQuery = { currentPage: 1, size: 10 }

        this.fromType = this.$route.query.type || '1'  // 1 展演预约 2 特展预约 3 讲解预约
        console.log('fromType', this.fromType)
        this.initList()
      },
      immediate: true
    }
  },
  methods: {
    // 初始化表格
    initList(type) {
      this.listLoading = true
      // this.$http.get('/activitynew/show/list', {
      this.$http.get(this.apiObj[this.fromType].listApi, {
        ...this.listQuery,
        name: this.form.name
        // ...this.form
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          this.tableData = res.result.records
          this.total = res.result.total
        }
      })
    },


    timeChange(arr) {
      if (!arr) {
        this.form.dateStart = ""
        this.form.dateEnd = ""
      } else {
        this.form.dateStart = arr[0]
        this.form.dateEnd = arr[1]
      }
    },


    // 重置查询
    restList() {
      this.time = []
      this.form.dateStart = ''
      this.form.dateEnd = ''

      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 删除
    handleDelete(id) {
      this.$common.confirm(
        {
          title: '删除数据',
          content: '该数据将被删除，请谨慎操作'
        },
        () => {
          this.$http
            .get(this.apiObj[this.fromType].deleteApi, {
              id: id
            })
            .then(res => {
              if (res.success) {
                this.$message.success('数据删除成功')
                this.initList('dele')
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },

    handleCancelAct(item) {
      console.log(item)
      this.$common.confirm(
        {
          title: '是否取消本场活动',
          content: `${item.activityName} ${item.activityTime} 至 ${item.activityEndTime}`
        },
        () => {
          this.$http
            .post('/activitynew/personal/common/cancel', {
            // .get(this.apiObj[this.fromType].deleteApi, {
              id: item.id
            })
            .then(res => {
              if (res.success) {
                this.$message.success('取消成功')
                this.initList()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },

    handlePublish(item) {
      // 1 已发布  0 待发布
      let apiUrl = item.status === '1' ? this.apiObj[this.fromType].unpublishApi : this.apiObj[this.fromType].publishApi
      this.$http
        .post(apiUrl, {
          id: item.id,
          // status: item.status === '2' ? '1' : '2', // 1-取消发布 2-发布
        })
        .then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.initList()
          } else {
            this.$message.error(res.message)
          }
        })
    },


    // handleTop(item) {
    //   this.$http
    //     .post('/bsInformationWeb/topOrNot', {
    //       id: item.id,
    //       top: item.top == '1' ? '0' : '1'
    //     })
    //     .then(res => {
    //       if (res.success) {
    //         this.$message.success(res.message)
    //         this.initList()
    //       } else {
    //         this.$message.error(res.message)
    //       }
    //     })
    // },


    handleCreate(type, id) {
      if (type === 'detail') {
        this.$router.push({
          path: '/reservation/lexuetang/detail',
          query: {
            id: id
          }
        })
      } else {
        this.$refs.dialogCreateInfo.init(type, id, this.fromType)
      }
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    }
  },
  // created() {
  //   this.initList()
  // }
}
</script>

<style lang="scss" scoped>
</style>